import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UrlUtils {
  parseURL(url: string, params: Record<string, any>): string {
    return Object.entries(params).reduce((acc: string, [key, value]: [string, any]) => {
      value = value ?? '';
      if (typeof value === 'object') value = JSON.stringify(value);
      return acc.replace(`{${key}}`, value);
    }, url);
  }
}
